import { DannoBiologico } from "./danno-biologico";

export class DannoBiologicoAdapter extends DannoBiologico {
    constructor(dannoBiologico: DannoBiologico) {
        super()
       this.dataDecesso =  dannoBiologico.dataDecesso ? dannoBiologico.dataDecesso : null;
       this.dataDiagnosi =  dannoBiologico.dataDiagnosi ? dannoBiologico.dataDiagnosi : null;
       this.dataRiconoscimentoMalattiaProfessionale =  dannoBiologico.dataRiconoscimentoMalattiaProfessionale ? dannoBiologico.dataRiconoscimentoMalattiaProfessionale : null;
       this.dataRilevazioneInvaliditaTemp =  dannoBiologico.dataRilevazioneInvaliditaTemp ? dannoBiologico.dataRilevazioneInvaliditaTemp : null;
       this.id =  dannoBiologico.id ? dannoBiologico.id : null;
       this.importoDannoBiologico =  dannoBiologico.importoDannoBiologico ? dannoBiologico.importoDannoBiologico : null;
       this.importoDannoMorale = dannoBiologico.importoDannoMorale ? dannoBiologico.importoDannoMorale : null;
       this.importoDannoMoraleEredi=  dannoBiologico.importoDannoMoraleEredi ? dannoBiologico.importoDannoMoraleEredi : null;
       this.importoInvaliditaTemp =   dannoBiologico.importoInvaliditaTemp ? dannoBiologico.importoInvaliditaTemp : null;
       this.note = dannoBiologico.note ? dannoBiologico.note : null;
       this.patologia = dannoBiologico.patologia ? dannoBiologico.patologia : null;
       this.percentualeAbbattimento =  dannoBiologico.percentualeAbbattimento ? dannoBiologico.percentualeAbbattimento : null;
       this.percentualeInvalidita = dannoBiologico.percentualeInvalidita ? dannoBiologico.percentualeInvalidita : null;
       this.riconoscimentoMalattiaProfessionale = dannoBiologico.riconoscimentoMalattiaProfessionale ? dannoBiologico.riconoscimentoMalattiaProfessionale : false;
    }
}
